module.exports = __webpack_public_path__ + "img/Rueda Segura.b88ed5b9.svg";